<template>
    <div>
        <card-header title="Session Details" icon="fa-users-class"/>

        <template v-if="session.deleted">
            <card-body padded>
                <i class="fas fa-exclamation-triangle mr-2 has-text-warning"></i>This session has been deleted.  You can close this card.
            </card-body>
        </template>
        <template v-else>
            <card-toolbar>
                <button @click="$openCard('conf-edit-session', {confId: session.conference_id, sessionId: session.id}, card)"><i class="far fa-pencil"></i>Edit Details</button>
            </card-toolbar>

            <card-body>
                <card-list>
                    <container-list-item>
                        <data-row title="Session Title">{{ session.title }}</data-row>
                        <data-row title="Session Type">{{ session.type | capitalize }}</data-row>
                        <data-row title="Starts" v-if="session.type !== 'on-demand'">{{ session.start_at | moment('MMM Do, YYYY h:mm A') }}</data-row>
                        <data-row title="Ends" v-if="session.type !== 'on-demand'">{{ session.end_at | moment('MMM Do, YYYY h:mm A') }}</data-row>
                    </container-list-item>

                    <separator-list-item/>

                    <navigation-list-item
                        title="Session Participants"
                        icon="fa-users"
                        @click="$openCard('conf-session-participants', {confId: props.confId, sessionId: props.sessionId}, card)"
                        :active="(child && child.definition.component === 'conf-session-participants')"
                    />

                    <!-- <navigation-list-item
                        title="Survey Responses"
                        icon="fa-poll-people"
                    /> -->

                    <navigation-list-item
                        title="Communication"
                        icon="fa-comment"
                    />


                    <!-- <subheader-list-item title="Setup" icon="fa-cogs"/> -->

                    <!-- <navigation-list-item
                        title="Survey Questions"
                        icon="fa-users-class"
                        @click="$openCard('rmc-session-survey-questions', {confId: conference.id, sessionId: session.id}, card)"
                        :active="(child && child.definition.component === 'rmc-session-survey-questions' && session.id === parseInt(child.props.sessionId))"
                    /> -->

                    <!-- <navigation-list-item
                        title="Materials & Handouts"
                        icon="fa-file-pdf"
                    /> -->

                </card-list>
            </card-body>
        </template>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import DataRow from "@/TIER/components/DataRow";

    import RmcConfTile from "@/components/rmc/RmcConfTile";

    import {client as http} from "@/http_client";
    import moment from "moment";
    import async from "async";

    export default {
        props: ['card', 'child', 'props'],
        components: {ContainerListItem, SeparatorListItem, RmcConfTile, DataRow, CardHeader, CardToolbar, CardBody, SearchListItem, NavigationListItem, SubheaderListItem, CardList},
        data() {
            return {
                session: {
                    enrollments: []
                },
                conference: {},
                tracks: [],
                groups: [],
            };
        },
        methods: {
            loadSession: function(force) {
                this.$emit('loading', true);
                async.series([
                    (cb) => {
                        http.get('conferences/' + this.props.confId, {force}).then(response => {
                            this.conference = response.data;
                            cb();
                        }).catch(err => {
                            cb(err);
                        });
                    },
                    (cb) => {
                        http.get('conferences/' + this.props.confId + '/sessions/' + this.props.sessionId, {force}).then(response => {
                            this.session = response.data;
                            this.$emit('title', response.data.title);
                            cb();
                        }).catch(err => {
                            cb(err);
                        });
                    }
                ], err => {
                    this.$emit('loading', false);
                })

            },
            reload: function() {
                this.loadSession(true);
            }
        },
        computed: {
            confDates: function() {
                let s = moment(this.conference.start_at);
                let e = moment(this.conference.end_at);
                if (s.isSame(e, 'day')) {
                    return s.format('MMMM D, YYYY');
                } else if (s.isSame(e, 'month')) {
                    return s.format('MMMM D - ') + e.format('D, YYYY');
                } else if (s.isSame(e, 'year')) {
                    return s.format('MMM D - ') + e.format('MMM D, YYYY');
                } else {
                    return s.format('MMM D, YYYY - ') + e.format('MMM D, YYYY');
                }
            }
        },
        watch: {
            'props.sessionId': function() {
                this.loadSession();
            }
        },
        mounted: function() {
            this.loadSession();
        }
    };
</script>

